import { styled } from '@mui/material';

import { ButtonsContainer, Button } from '@app-velocity/ui';
import { Loader } from '@app-velocity/animations';

import { useI18n } from '@app-velocity/i18n';

import { Page } from '../../../../../../../layouts';
import { SaveScenarioProgress } from '../SaveScenarioProgress';
import { LoadingQuote } from './components/LoadingQuote';

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  flex: 1,
  gap: theme.spacing(12),
}));

const MainContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(6),
}));

export type LoadingScreenProps = {
  pagesCount: number;
  savedPagesCount: number;
  partialsCount: number;
  savedPartialsCount: number;
  finishedCount: number;
  totalToFinish: number;
  abort: () => void;
};

export const LoadingScreen = ({
  pagesCount,
  savedPagesCount,
  partialsCount,
  savedPartialsCount,
  totalToFinish,
  finishedCount,
  abort,
}: LoadingScreenProps) => {
  const { t } = useI18n();

  const handleAbort = () => {
    abort();
  };

  return (
    <Page>
      <Wrapper>
        <span />
        <MainContent>
          <Loader />
          <SaveScenarioProgress
            pagesCount={pagesCount}
            savedPages={savedPagesCount}
            partialsCount={partialsCount}
            savedPartials={savedPartialsCount}
            finishedCount={finishedCount}
            totalToFinish={totalToFinish}
          />
          <LoadingQuote />
        </MainContent>
        <ButtonsContainer>
          <Button variant="contained" color="secondary" onClick={handleAbort}>
            {t('prototypes:abort')}
          </Button>
        </ButtonsContainer>
      </Wrapper>
    </Page>
  );
};
